const ANNUAL = 'annual'
const MONTHLY = 'monthly'

const fixedNumber = number => Number(number.toFixed(2))
export const getYearlyPrice = (price, recurrence) =>
  fixedNumber(recurrence === ANNUAL ? price : price * 12)
export const getMonthlyPrice = (price, recurrence) =>
  fixedNumber(recurrence === MONTHLY ? price : price / 12)

const createPlan = ({ idEnv, priceEnv, recurrence, fallback }) => {
  const id = process.env[idEnv] ?? fallback.id
  const priceEnvValue = parseFloat(process.env[priceEnv], 10)
  const price = Number.isNaN(priceEnvValue) ? fallback.price : priceEnvValue
  return {
    id,
    price,
    recurrence,
    yearly: getYearlyPrice(price, recurrence),
    monthly: getMonthlyPrice(price, recurrence),
  }
}

export const annualPlan = createPlan({
  idEnv: 'REACT_APP_CHARGEBEE_ANNUAL_PLAN_ID',
  priceEnv: 'REACT_APP_ANNUAL_PRICE',
  recurrence: ANNUAL,
  fallback: {
    id: 'annual',
    price: 36,
  },
})

export const monthlyPlan = createPlan({
  idEnv: 'REACT_APP_CHARGEBEE_MONTHLY_PLAN_ID',
  priceEnv: 'REACT_APP_MONTHLY_PRICE',
  recurrence: MONTHLY,
  fallback: {
    id: 'monthly',
    price: 9.95,
  },
})

export const annualPricierPlan = createPlan({
  idEnv: 'REACT_APP_CHARGEBEE_ANNUAL_PRICIER_PLAN_ID',
  priceEnv: 'REACT_APP_ANNUAL_PRICIER_PLAN_PRICE',
  recurrence: ANNUAL,
  fallback: {
    id: 'annual_39',
    price: 39,
  },
})

export const monthlyPricierPlan = createPlan({
  idEnv: 'REACT_APP_CHARGEBEE_MONTHLY_PRICIER_PLAN_ID',
  priceEnv: 'REACT_APP_MONTHLY_PRICIER_PLAN_PRICE',
  recurrence: MONTHLY,
  fallback: {
    id: 'monthly_1075',
    price: 10.75,
  },
})

const plans = {
  [annualPlan.id]: annualPlan,
  [monthlyPlan.id]: monthlyPlan,
  [annualPricierPlan.id]: annualPricierPlan,
  [monthlyPricierPlan.id]: monthlyPricierPlan,
}

export const getPlanById = plan => plans[plan] ?? {}

export const isAnnualRecurrence = plan =>
  getPlanById(plan).recurrence === ANNUAL

export const isMonthlyRecurrence = plan =>
  getPlanById(plan).recurrence === MONTHLY
